/**
 * ScrollReveal - animace elementů při scrollování
 *
 * Oblast: .scrool-reveal-block
 * Elementy: [data-scrool-reveal="typ"]
 * Typy: category, up, down, left, right, zoom, fade
 */

/**
 * Zjistí kolik procent elementu je viditelných ve viewportu
 */
function getVisiblePercent(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    if (rect.bottom < 0 || rect.top > windowHeight) return 0;
    var visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    return visibleHeight / rect.height;
}

/**
 * Inicializuje scroll reveal animace
 * Najde všechny .scrool-reveal-block kontejnery a nastaví IntersectionObserver
 */
export function initialize() {
    var revealBlocks = document.querySelectorAll('.scrool-reveal-block');
    if (revealBlocks.length === 0) return;

    // Observer pro scrollování - spustí animaci při 30%
    var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            }
        });
    }, {
        threshold: 0.30,
        rootMargin: '0px'
    });

    revealBlocks.forEach(function(block) {
        // Aktivuje CSS animace (bez JS zůstanou bloky viditelné)
        block.classList.add('scrool-reveal-ready');
        var elements = block.querySelectorAll('[data-scrool-reveal]');
        elements.forEach(function(el) {
            // Při načtení - zobrazit pokud je vidět alespoň 3%
            if (getVisiblePercent(el) >= 0.03) {
                el.classList.add('is-visible');
            } else {
                // Ostatní sledovat observerem (animace při 30%)
                revealObserver.observe(el);
            }
        });
    });
}
